import React, { useEffect } from "react";
import "./Index.scss";
import Button from "../../components/Button/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import question from "../../assets/images/question.svg";
import logo from "../../assets/logo.png";
import vector from "../../assets/logo.svg";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { loginValidationSchema } from "./validation";
import { useSelector, useDispatch } from "react-redux";
import { doLogin } from "../../http/auth.service";
import FullpageLoader from "../../components/FullPageLoader";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((data) => data.auth.logged);
  const role = useSelector((data) => data.auth?.currentUser?.role);
  const fullPageLoader = useSelector((data) => data.loader.fullPageLoader);

  useEffect(() => {
    if (isLoggedIn === true) {
      // Check if token exists before navigating
      const token = localStorage.getItem("token");
      if (token) {
        if (role == "Admin") {
          // Use setTimeout to ensure token is fully saved
          setTimeout(() => {
            window.location.replace("/admin/dashboard");
          }, 100);
        }
        // else if (role === 2) {
        //   window.location.replace("/clinic/dashboard");
        // } else if (role === 3) {
        //   window.location.replace("/agent/dashboard");
        // }
      } else {
        console.error("Token not found after login");
      }
    }
  }, [isLoggedIn, role]);

  const handleLogin = async (values, actions) => {
    await doLogin(dispatch, values, actions);
  };

  return (
    <div className="main-wrapper">
      {fullPageLoader && <FullpageLoader />}
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        validationSchema={loginValidationSchema}
        onSubmit={(values, actions) => {
          handleLogin(values, actions);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Container fluid>
            <Row>
              <Col>
                <div className="row graphical-vector">
                  <img src={logo} />
                </div>
              </Col>
              <Col>
                <div className="row user-form">
                  <div className="user-form-inner">
                    <div className="form-outer-bg">
                      <h2>Login</h2>
                      <Form onSubmit={handleSubmit}>
                        <div className="form-container">
                          {/* Email Field */}
                          <Form.Group
                            className="form-margin form-group"
                            controlId="formBasicEmail"
                          >
                            <Form.Label className="label-inline">
                              <div>
                                <span>Email</span>
                                <span className="req">*</span>
                              </div>
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleChange}
                              value={values.email}
                              placeholder="Email address"
                              className={
                                touched.email && errors.email ? "error" : null
                              }
                            />
                            {touched.email && errors.email && (
                              <div className="error-message">
                                {errors.email}
                              </div>
                            )}
                          </Form.Group>

                          {/* Password Field */}
                          <Form.Group
                            controlId="formBasicPassword"
                            className="form-group"
                          >
                            <Form.Label className="label-inline">
                              <div>
                                <span>Password</span>
                                <span className="req">*</span>
                              </div>
                              <img src={question} alt="Info" />
                            </Form.Label>
                            <Form.Control
                              type="password"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleChange}
                              value={values.password}
                              placeholder="Password"
                              className={
                                touched.password && errors.password
                                  ? "error"
                                  : null
                              }
                            />
                            {touched.password && errors.password && (
                              <div className="error-message">
                                {errors.password}
                              </div>
                            )}
                          </Form.Group>

                          {/* Forgot Password Link */}
                          <Link
                            to="/forgot-password"
                            className="forgot-password-link"
                          >
                            Forgot password?
                          </Link>

                          {/* Submit Button */}
                          <Button
                            name="Login"
                            type="submit"
                            disabled={isSubmitting}
                          />
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        )}
      </Formik>
    </div>
  );
};

export default Login;

// console.log(data)
